export const FULLSCREEN = 'Fullscreen';
export const LEAVE_FULLSCREEN = 'Leave Fullscreen';
export const INCOMING_REFERENCE_TYPES = 'Incoming reference types';
export const OUTGOING_REFERENCE_TYPES = 'Outgoing reference types';
export const SHOW_ALL = 'Show all';
export const SHOW_NONE = 'Show none';
export const FULLSCREEN_KEY = 'fullScreen';
export const IS_LEGEND_ACTIVE = 'isLegendActive';
export const DEGREES_OF_RELATIONSHIP_SLIDER_MENU_ITEM_ID =
  'slider-degrees-of-relationship';

/**
 * @deprecated use viewSettingsConsts from @ardoq/view-settings instead
 */
export const settingsBarConsts = {
  FULLSCREEN,
  LEAVE_FULLSCREEN,
  INCOMING_REFERENCE_TYPES,
  OUTGOING_REFERENCE_TYPES,
  SHOW_ALL,
  SHOW_NONE,
  FULLSCREEN_KEY,
  IS_LEGEND_ACTIVE,
  DEGREES_OF_RELATIONSHIP_SLIDER_MENU_ITEM_ID,
} as const;
